import { Routes } from '@angular/router';
import { LoginComponent } from './authentication/login/login.component';
import { SignupComponent } from './authentication/signup/signup.component';
import { ShopComponent } from './shop/shop.component';
import { pagesRoutes } from './pages/pages.routes';
import { ProductComponent } from './product/product.component';
import { settingsRoutes } from './settings/settings.routes';
import { authGuard, checkAbandoneOrNoAddressdUser, maintenanceGuard, checkMembershipPermissions, maintenanceOffGuard, preventForAbandoneOrNoAddressdUser, signupCompletedGuard } from './shared/guards/auth-guard.guard';
import { HomeComponent } from './home/home.component';
import { OrderComponent } from './order/order.component';
import { TermsAndConditionsComponent } from './authentication/signup/terms-and-conditions/terms-and-conditions.component';
import { accountRecoveryRoutes } from './authentication/account-recovery/account-recovery.routes';
import { FavProductsComponent } from './fav-products/fav-products.component';
import { BuyAgainProductsComponent } from './buy-again-products/buy-again-products.component';
import { CartPreviewComponent } from './cart-preview/cart-preview.component';
import { canDeactivateGuard } from './shared/guards/deactivate/can-deactivate.guard';
import { MaintenanceComponent } from './maintenance/maintenance.component';
import { EcommerceAdminComponent } from './authentication/ecommerce-admin/ecommerce-admin.component';
import { SignupV2Component } from './authentication/signup-v2/signup-v2.component';
import { ShopOrProductComponent } from './shop/shop-or-product/shop-or-product.component';

export const routes: Routes = [
  {
    path: 'maintenance',
    title: 'Maintenance',
    component: MaintenanceComponent,
    canActivate: [maintenanceOffGuard]
  },
  {
    path: 'ecommerce-admin/:token',
    title: 'Ecommerce Admin',
    component: EcommerceAdminComponent,
    canActivate: [maintenanceGuard]
  },
  {
    path: '',
    title: 'Home',
    component: HomeComponent,
    canActivate: [maintenanceGuard]
  },
  {
    path: 'login',
    title: 'Log In',
    component: LoginComponent,
    canActivate: [maintenanceGuard, authGuard]
  },
  {
    path: 'signup',
    title: 'Sign Up',
    component: SignupV2Component,
    canActivate: [maintenanceGuard, signupCompletedGuard]
  },
  ...pagesRoutes,
  ...settingsRoutes,
  ...accountRecoveryRoutes,
  {
    path: 'shop',
    component: ShopComponent,
    canActivate: [maintenanceGuard, checkMembershipPermissions, checkAbandoneOrNoAddressdUser],
    canActivateChild: [maintenanceGuard]

  },
  {
    path: 'shop/:category',
    component: ShopComponent,
    canActivate: [maintenanceGuard, checkMembershipPermissions, checkAbandoneOrNoAddressdUser]

  },
  {
    path: 'shop/:category/:subcategory',
    component: ShopComponent,
    canActivate: [maintenanceGuard, checkMembershipPermissions, checkAbandoneOrNoAddressdUser]

  },
  {
    path: 'shop/:category/:subcategory/:slug',
    component: ShopOrProductComponent,
    canActivate: [maintenanceGuard, checkMembershipPermissions]

  },
  {
    path: 'favorites',
    title: 'Favorites',
    component: FavProductsComponent,
    canActivate: [maintenanceGuard, checkMembershipPermissions]

  },
  {
    path: 'buy-again',
    title: 'Buy again',
    component: BuyAgainProductsComponent,
    canActivate: [maintenanceGuard, checkMembershipPermissions]

  },
  {
    path: 'order',
    title: 'Order',
    component: OrderComponent,
    canActivate: [maintenanceGuard, checkMembershipPermissions, preventForAbandoneOrNoAddressdUser],
    canDeactivate: [canDeactivateGuard]
  },
  {
    path: 'cart',
    title: 'Cart',
    component: CartPreviewComponent,
    canActivate: [maintenanceGuard, checkMembershipPermissions]
  },
  {
    path: 'terms-and-conditions',
    title: 'Terms & Conditions',
    component: TermsAndConditionsComponent,
    canActivate: [maintenanceGuard]
  },
  { path: '**', redirectTo: '' },
];
